// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLoaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  position: relative;
  overflow: hidden;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.item1, .item2, .item3 {
  position: absolute;
  background-color: var(--Foreground);
  left: calc(50% - var(--size) / 2);
  top: calc(50% - var(--size) / 2);
  height: var(--size);
  width: var(--size);
  border-radius: 50%;
  animation: spin 2.5s linear infinite;
}

.MainLoader .item1 {
  --size: 90px;
  animation: size1_1 2.5s infinite alternate;
  z-index: 1;
}

.MainLoader .item2 {
  --size: 60px;
  animation: size1_2 2.5s infinite alternate;
  z-index: 2;
}

.MainLoader .item3 {
  --size: 30px;
  animation: size1_3 2.5s infinite alternate;
  z-index: 3;
}

@keyframes size1_1 {
  0%, 10% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    box-shadow: 8px 8px 14px var(--Background), -8px -8px 14px var(--Hover);
  }
}
@keyframes size1_2 {
  0%, 40% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    box-shadow: 8px 8px 14px var(--Background), -8px -8px 14px var(--Hover);
  }
}
@keyframes size1_3 {
  0%, 70% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    box-shadow: 8px 8px 14px var(--Background), -8px -8px 14px var(--Hover);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Loader/MainLoader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mCAAA;EACA,iCAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,YAAA;EACA,0CAAA;EACA,UAAA;AAAF;;AAGA;EACE,YAAA;EACA,0CAAA;EACA,UAAA;AAAF;;AAGA;EACE,YAAA;EACA,0CAAA;EACA,UAAA;AAAF;;AAGA;EACE;IAEE,mBAAA;EADF;EAIA;IACE,mBAAA;IACA,uEAAA;EAFF;AACF;AAKA;EACE;IAEE,mBAAA;EAJF;EAOA;IACE,mBAAA;IACA,uEAAA;EALF;AACF;AAQA;EACE;IAEE,mBAAA;EAPF;EAUA;IACE,mBAAA;IACA,uEAAA;EARF;AACF","sourcesContent":[".MainLoaderContainer{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.item1, .item2, .item3 {\n  position: absolute;\n  background-color: var(--Foreground);\n  left: calc(50% - (var(--size) / 2));\n  top: calc(50% - (var(--size) / 2));\n  height: var(--size);\n  width: var(--size);\n  border-radius: 50%;\n  animation: spin 2.5s linear infinite;\n}\n\n.MainLoader .item1 {\n  --size: 90px;\n  animation: size1_1 2.5s infinite alternate;\n  z-index: 1;\n}\n\n.MainLoader .item2 {\n  --size: 60px;\n  animation: size1_2 2.5s infinite alternate;\n  z-index: 2;\n}\n\n.MainLoader .item3 {\n  --size: 30px;\n  animation: size1_3 2.5s infinite alternate;\n  z-index: 3;\n}\n\n@keyframes size1_1 {\n  0%,\n  10% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 8px 8px 14px  var(--Background), -8px -8px 14px  var(--Hover);\n  }\n}\n\n@keyframes size1_2 {\n  0%,\n  40% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 8px 8px 14px  var(--Background), -8px -8px 14px  var(--Hover);\n  }\n}\n\n@keyframes size1_3 {\n  0%,\n  70% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n    box-shadow: 8px 8px 14px  var(--Background), -8px -8px 14px  var(--Hover);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
